import axios from 'axios';
import { call, all, put, takeLatest, select } from 'redux-saga/effects';

import * as dailyRouteReportActions from './daily-route-report-actions';

import { saveAs } from 'file-saver';

import { GET_LIST_ALL_REQUEST, GET_LIST_SELECTS_REQUEST, SHARE_CSV } from './daily-route-report-constants';

import notification from '~/services/notification';
import dailyRouteReportServices from './daily-route-report-service';

import { ISA_ERROR, USER_ROLE } from '~/constants';

import { AppStateType } from '../root-reducer';

import { formatDateTime, formatMessage } from '~/i18n/translate';
import { UserInterface } from '@e3labs/isa-data-dictionary';

let cancel: any;
const CancelToken = axios.CancelToken;

export function* getAllDailyReportReport({
  type,
  payload
}: {
  type: any;
  payload: {
    date: Date[];
    sellers: UserInterface[];
    type: string;
  };
}) {
  if (cancel !== undefined) cancel();
  const cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  });

  try {
    yield put(dailyRouteReportActions.setLoadingData(true));

    const { rowsPerPage, page, order, orderBy } = yield select((state: AppStateType) => state.dailyRouteReport.list);

    const params = {
      beginDate: payload?.date
        ? payload?.date[0]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      endDate: payload?.date
        ? payload?.date[1]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      userExternalCodes: payload?.sellers?.map(seller => seller.externalCode)?.join(',') ?? '',
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      order,
      orderBy
    };

    const [{ data: successDailyRouteReports }] = yield all([
      call(
        dailyRouteReportServices.getListSuccessDailyRouteReports,
        {
          ...params
        },
        {
          cancelToken
        }
      )
      // call(dailyRouteReportServices.getSuccessRowCount, {
      //   ...params
      // })
    ]);

    yield put(
      dailyRouteReportActions.getAllDailyReportReportsSuccess({
        dailyRouteReports: [...successDailyRouteReports]
        // rowsCount: successRowsCount.count
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(dailyRouteReportActions.setLoadingData(false));
  }
}

export function* getSelects() {
  try {
    yield put(dailyRouteReportActions.setLoadingSelects(true));

    const { data: sellers } = yield call(dailyRouteReportServices.getSellers);

    yield put(
      dailyRouteReportActions.getListSelectsSuccess({
        selects: {
          sellers: sellers?.filter(seller => seller?.userRole === USER_ROLE?.VENDOR)
        }
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(dailyRouteReportActions.setLoadingSelects(false));
  }
}

export function* shareCSV({ payload, exportType }: any) {
  const toast: any = notification.loading(formatMessage('commonLoadingMessage'));

  try {
    const params = {
      beginDate: payload?.date
        ? payload?.date[0]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      endDate: payload?.date
        ? payload?.date[1]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      userExternalCodes: payload?.sellers?.map(seller => seller.externalCode)?.join(',') ?? ''
    };

    if (exportType === 'xlsx') {
      let data;

      data = yield call(dailyRouteReportServices.getXslxSuccessDailyRouteReports, params);

      const xlsx = data?.data;

      const blob = new Blob([xlsx], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(
        blob,
        `Relatório de Rota Diária - ${payload?.type === 'success' ? 'Sucesso' : 'Falha'} - ${formatDateTime(
          new Date()
        )}.xlsx`
      );
    } else {
      let data;

      data = yield call(dailyRouteReportServices.getCSVSuccessDailyRouteReports, params);

      const csv = data?.data;

      const reader = new FileReader();

      const blobFile = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

      reader.readAsDataURL(blobFile);
      reader.onloadend = async function () {
        saveAs(
          blobFile,
          `Relatório de Rota Diária - ${payload?.type === 'success' ? 'Sucesso' : 'Falha'} - ${formatDateTime(
            new Date()
          )}.csv`
        );
      };
    }
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    toast.close();
  }
}

export default all([
  takeLatest(GET_LIST_ALL_REQUEST, getAllDailyReportReport),
  takeLatest(GET_LIST_SELECTS_REQUEST, getSelects),
  takeLatest(SHARE_CSV, shareCSV)
]);
